<script lang="ts">
	import { browser, dev } from '$app/env';
	import { page } from '$app/state';
	import GlobalConfirmationModal from '#lib/component/GlobalConfirmationModal.svelte';
	import ServiceWorker from '#lib/component/navigation/ServiceWorker.svelte';
	import DiagnosticsFloatingButton from '#lib/modern/diagnostics/DiagnosticsFloatingButton.svelte';
	import DiagnosticsModal from '#lib/modern/DiagnosticsModal.svelte';
	import { adminStore } from '#lib/stores/admin.js';
	import {
		closeDiagnostics,
		initGlobalDiagnosticsListener,
		isDiagnosticsModalOpen,
		openDiagnostics,
		recordNavigation
	} from '#lib/stores/diagnostics.js';
	import '@fontsource-variable/raleway';
	import '@fontsource-variable/raleway/wght-italic.css';
	import { onMount } from 'svelte';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	onMount(() => {
		initGlobalDiagnosticsListener();
	});

	let previousPath: string | null = null;
	$effect(() => {
		const currentPath = page.url.pathname;
		if (currentPath !== previousPath) {
			recordNavigation(previousPath, currentPath);
			previousPath = currentPath;
		}
	});

	let canAccessDiagnostics = $derived(browser && (dev || $adminStore));

	function handleGlobalKeydown(e: KeyboardEvent): void {
		if (!canAccessDiagnostics) return;

		const target = e.target as HTMLElement | null;
		if (
			target &&
			(target.tagName === 'INPUT' ||
				target.tagName === 'TEXTAREA' ||
				target.isContentEditable)
		) {
			return;
		}

		if (
			e.shiftKey &&
			!e.metaKey &&
			!e.ctrlKey &&
			!e.altKey &&
			(e.key.toLowerCase() === 'd' || e.code === 'KeyD')
		) {
			e.preventDefault();
			if ($isDiagnosticsModalOpen) {
				closeDiagnostics();
			} else {
				openDiagnostics();
			}
		}
	}
</script>

<svelte:window onkeydown={handleGlobalKeydown} />

<ServiceWorker />
<GlobalConfirmationModal />
{@render children?.()}

{#if canAccessDiagnostics}
	<DiagnosticsFloatingButton />
	<DiagnosticsModal />
{/if}
